/* global angular, moment, $ */

// Rss URL
// http://blogs.guggenheim.org/tag/zero/feed/
angular.module('ua5App.index.blog')
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('index.blog', {
            url: 'blog',
            templateUrl: 'states/index.blog/index.blog.html',
            controller: 'BlogCtrl',
            controllerAs: 'ctrl',
            reloadOnSearch: false,
            resolve: {
                // Posts Resolve Here //
                feeds: ['feedService', function(feedService) {
                    return feedService.parseFeed('http://blogs.guggenheim.org/tag/storylines/feed/');
                }]
            }
        });
    }])
    .controller('BlogCtrl', [
    'feeds',
    '$filter',
    '$stateParams',
    '$scope',
    '$timeout',
    'MetaFactory',
    function(feeds, $filter, $stateParams, $scope, $timeout, MetaFactory) {

        $scope.feeds = feeds.data.responseData.feed.entries;
        angular.forEach($scope.feeds, function(feed, index) {
            feed.publishedDate = moment(feed.publishedDate).format('MMMM D, YYYY');
            feed.image = $(feed.content)[0].src;
        });

        MetaFactory.set({
            title: 'Blog | Storylines: Contemporary Art at the Guggenheim',
            ogTitle: 'Blog | Storylines: Contemporary Art at the Guggenheim'
        });
    }])
;
